import { createReducer, on } from '@ngrx/store';
import * as StartRecordActions from '../actions/start-record.actions';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';

export const startRecordFeatureKey = 'startRecord';

export interface State {
  record: DvrRecord | null;
  error: unknown | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(StartRecordActions.startRecord, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(StartRecordActions.startRecordSuccess, (_state: State, action: {data: DvrRecord}): State => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(StartRecordActions.startRecordFailure, (_state: State, action: {error: unknown}): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(StartRecordActions.clearStartRecordState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

